import { useHistory } from 'react-router-dom';
import * as React from 'react';

import { Layer } from 'bernie-view';
import { QueryRoute } from 'bernie-core';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';

export const MoreDetailsLx = ({ action }) => {
  const history = useHistory();
  const closeAction = () => {
    history.goBack();
  };

  return (
    <QueryRoute query={{ pwaDialog: 'freeLxTerms' }}>
      <Layer id="free-lx-terms" onDismiss={closeAction}>
        <UitkFullscreenDialog strictFullscreen={false}>
          <UitkToolbar header={action.text} iconLabel="close.dialog" action={closeAction} type={ToolbarType.CLOSE} />
          <UitkDialogContent>
            <div className="all-t-padding-two all-l-padding-six" dangerouslySetInnerHTML={{ __html: action.actionDetails.details }} />
          </UitkDialogContent>
        </UitkFullscreenDialog>
      </Layer>
    </QueryRoute>
  );
};
